import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasProduct, ProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import NISCustomProductAvailability from "@tCentro/Components/NISCustomProductAvailability";
import { NISProductAvailabilityStyles } from "@tCentro/Components/NISProductAvailability";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    isProductDetailsPage?: boolean;
    configurationCompleted?: boolean;
    extendedStyles?: NISProductAvailabilityStyles;
    getFasterModalIsOpen?: boolean;
    setGetFasterModalIsOpen: (value: boolean) => void;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        includeRealTimeInventoryAndPricingForSeo:
            getSettingsCollection(state).websiteSettings.includeRealTimeInventoryAndPricingForSeo,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProduct;

const NISCustomProductContextAvailability = ({
    includeRealTimeInventoryAndPricingForSeo,
    productInfo,
    product,
    isProductDetailsPage,
    configurationCompleted,
    extendedStyles,
    getFasterModalIsOpen,
    setGetFasterModalIsOpen,
}: Props) => {
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;

    const productContext = React.useContext(ProductContext);

    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    if (
        (getIsWebCrawler() && !includeRealTimeInventoryAndPricingForSeo) ||
        product.isVariantParent ||
        (!!product.configurationType &&
            product.configurationType !== ConfigurationType.None &&
            product.configurationType !== ConfigurationType.Fixed &&
            !configurationCompleted)
    ) {
        return null;
    }

    return (
        <NISCustomProductAvailability
            productId={product.id}
            trackInventory={product.trackInventory}
            availability={availability}
            unitOfMeasure={unitOfMeasure}
            isProductDetailsPage={isProductDetailsPage}
            failedToLoadInventory={failedToLoadInventory}
            extendedStyles={extendedStyles}
            productContext={productContext}
            getFasterModalIsOpen={getFasterModalIsOpen}
            setGetFasterModalIsOpen={setGetFasterModalIsOpen}
        />
    );
};

export default withProduct(connect(mapStateToProps)(NISCustomProductContextAvailability));
